// extracted by css-extract-rspack-plugin
var _1 = "tx75m8v8dsjr2yG5";
var _2 = "DdVpeDv8Dbopvosx";
var _3 = "JQ808XliuusCSI11";
var _4 = "DdVpeDv8Dbopvosx";
var _5 = "JQ808XliuusCSI11";
var _6 = "iBXRLAMrXrc98WEE";
export { _1 as "avatar", _2 as "login-btn", _3 as "login-btn--rounded", _4 as "loginBtn", _5 as "loginBtnRounded", _6 as "username" }
